// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1fuRp","col":"Table_col__1A2if","fulfillmentStatus":"Table_fulfillmentStatus__2xCdg","emailCol":"Table_emailCol__2Evk0"};